// Generates a readable 6-char session code, avoiding ambiguous chars (0/O, 1/I/l)
const CHARS = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';

export function generateSessionCode() {
  let code = '';
  for (let i = 0; i < 6; i++) {
    code += CHARS[Math.floor(Math.random() * CHARS.length)];
  }
  return code;
}

export const GROUP_COLORS = [
  '#E05500', // orange  – Grupp 1
  '#185FA5', // blå     – Grupp 2
  '#0F6E56', // grön    – Grupp 3
  '#854F0B', // amber   – Grupp 4
  '#6B3FA0', // lila    – Grupp 5
  '#B5002B', // röd     – Grupp 6
];

export const QUESTION_TYPES = [
  { value: 'fritext', label: 'Fritext' },
  { value: 'skala',   label: 'Skala 1–5' },
  { value: 'flerval', label: 'Flerval' },
  { value: 'ordmoln', label: 'Ordmoln' },
];
